import { message } from 'antd';
import { mtop } from '../../utils';

export default {
  namespace: 'oss',
  state: {
    ossToken: {},
    ossPath: '',
  },
  reducers: {
    setOssToken(state, { response: ossToken }) {
      return {
        ...state,
        ossToken,
      };
    },
    setOssPath(state, { response: ossPath }) {
      return {
        ...state,
        ossPath,
      };
    },
  },
  effects: {
    * getOssToken({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'oss.signature.get', {
          ...payload,
        });
        yield put({ type: 'setOssToken', response });
        yield call(payload.resolve)
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setOssToken', response: {} });
        yield call(payload.reject)
      }
    },
    * getOssPath({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'oss.access.url.get', {
          ...payload,
        });
        yield put({ type: 'setOssPath', response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setOssPath', response: {} });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/common/oss.js